import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSection from 'components/PageSection';
import SEO from 'components/SEO';
import { SectionTitle } from 'components/Typography';
import appConfig from 'config/appConfig';
import Button from 'components/Button';
import LocalizedLink from 'components/LocalizedLink';
import { paths } from 'constants';

const Feedback = () => {
    const { t } = useTranslation('misc');
    return (
        <PageSection
            color="inverted"
            element="main"
            className={`pb-16 lg:pb-32 border-b-1 border-primary-300 ${
                appConfig.layout.header.fixed ? 'pt-12 lg:pt-16' : 'pt-4 lg:pt-8'
            }`}
            containerClass="flex flex-col md:flex-row gap-16"
        >
            <SEO title={t('feedback.meta.title')} description={t('feedback.meta.description')} />
            <div className="flex-1 flex flex-col items-center md:items-start lg:items-center gap-4">
                <SectionTitle className="text-white">{t('feedback.title')}</SectionTitle>
                <p className="text-center md:text-left lg:text-center">{t('feedback.body')}</p>
                <LocalizedLink to={paths.home}>
                    <Button color="secondary" element="div">
                        {t('feedback.cta')}
                    </Button>
                </LocalizedLink>
            </div>
        </PageSection>
    );
};

export default Feedback;
